{
  "SET_NEW_PASSWORD": {
    "TITLE": "Setați o nouă parolă",
    "PASSWORD": {
      "LABEL": "Parola",
      "PLACEHOLDER": "Parola",
      "ERROR": "Parola este prea scurta."
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Confirmă parola",
      "PLACEHOLDER": "Confirmă parola",
      "ERROR": "Parola nu coincide."
    },
    "API": {
      "SUCCESS_MESSAGE": "Parola a fost schimbată cu succes.",
      "ERROR_MESSAGE": "Nu s-a putut conecta la serverul Woot. Vă rugăm să încercați din nou."
    },
    "CAPTCHA": {
      "ERROR": "Verificarea a expirat. Vă rugăm să rezolvați captcha din nou."
    },
    "SUBMIT": "Trimite"
  }
}
